import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

// Re-pinta el elemento con el HTML que Horizon ya re-renderiza al cambiar de variante.
class NaoVariantRefresh extends HTMLElement {
  connectedCallback() {
    this.closest('.shopify-section, dialog')?.addEventListener(ThemeEvents.variantUpdate, this.update);
  }

  disconnectedCallback() {
    this.closest('.shopify-section, dialog')?.removeEventListener(ThemeEvents.variantUpdate, this.update);
  }

  /** @param {CustomEvent} event */
  update = (event) => {
    const { newProduct, html } = event.detail.data;
    if (newProduct) {
      this.dataset.productId = newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const fresh = html?.querySelector(this.localName);
    if (!fresh) return;

    this.hidden = fresh.hidden;
    this.className = fresh.className;
    morph(this, fresh, { childrenOnly: true });
  };
}

for (const tag of ['nao-stock-badge', 'nao-delivery-estimate']) {
  if (!customElements.get(tag)) customElements.define(tag, class extends NaoVariantRefresh {});
}
